// 产品模拟数据
const products = [
  // Mailer Box 系列
  {
    id: 1,
    name: 'Biodegradable Wig Clothes Sweater Festive Packaging Kraft Tear Strip Paper Shipping Mailer Boxes With Custom Logo',
    category: 'Mailer Box',
    categoryId: 1,
    image: 'https://via.placeholder.com/400x400/f5f5f5/333333?text=Mailer+Box+1',
    images: [
      'https://via.placeholder.com/600x600/f5f5f5/333333?text=Mailer+Box+1-1',
      'https://via.placeholder.com/600x600/eeeeee/333333?text=Mailer+Box+1-2',
      'https://via.placeholder.com/600x600/e0e0e0/333333?text=Mailer+Box+1-3'
    ],
    moq: '500 pieces',
    priceRange: '$0.50 - $2.00',
    description: 'High quality biodegradable kraft paper mailer boxes with custom logo printing. Perfect for clothing and sweater packaging.',
    specifications: [
      { label: 'Material', value: 'Kraft Paper + Corrugated' },
      { label: 'Size', value: 'Custom Size' },
      { label: 'Color', value: 'Brown/Custom' },
      { label: 'Printing', value: 'CMYK/Pantone' },
      { label: 'MOQ', value: '500 Pieces' },
      { label: 'Sample Time', value: '5-7 Days' }
    ]
  },
  {
    id: 2,
    name: 'Custom Blue Insert Corrugated Cardboard Foldable Gift Packaging With Fixed Paper Tray Shipping Carton Box',
    category: 'Mailer Box',
    categoryId: 1,
    image: 'https://via.placeholder.com/400x400/e3f2fd/333333?text=Mailer+Box+2',
    images: [
      'https://via.placeholder.com/600x600/e3f2fd/333333?text=Mailer+Box+2-1',
      'https://via.placeholder.com/600x600/bbddff/333333?text=Mailer+Box+2-2'
    ],
    moq: '500 pieces',
    priceRange: '$0.80 - $2.50',
    description: 'Custom blue insert corrugated cardboard foldable gift packaging with fixed paper tray for shipping.',
    specifications: [
      { label: 'Material', value: 'Corrugated Cardboard' },
      { label: 'Size', value: 'Custom Size' },
      { label: 'Color', value: 'Blue/Brown' },
      { label: 'Printing', value: 'CMYK' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 3,
    name: 'Flexography Matt Lamination Sponge Lined Corrugated Cardboard Hard Packaging Inserts Folding Box',
    category: 'Mailer Box',
    categoryId: 1,
    image: 'https://via.placeholder.com/400x400/fff3e0/333333?text=Mailer+Box+3',
    images: [],
    moq: '500 pieces',
    priceRange: '$0.60 - $1.80',
    description: 'Matt lamination sponge lined corrugated cardboard packaging with custom inserts.',
    specifications: [
      { label: 'Material', value: 'Corrugated + Sponge' },
      { label: 'Finish', value: 'Matt Lamination' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 4,
    name: 'Personalized Custom Lingerie Underwear Fur Socks Recyclable White Corrugated Cardboard Folding Gift Box',
    category: 'Mailer Box',
    categoryId: 1,
    image: 'https://via.placeholder.com/400x400/f5f5f5/333333?text=Mailer+Box+4',
    images: [],
    moq: '500 pieces',
    priceRange: '$0.45 - $1.50',
    description: 'Recyclable white corrugated cardboard folding gift box for lingerie and underwear packaging.',
    specifications: [
      { label: 'Material', value: 'White Corrugated' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 5,
    name: 'Wholesale Bulk E Flute Corrugated Mailer Carton Custom Box Logo Minimalist Jewelry Packaging',
    category: 'Mailer Box',
    categoryId: 1,
    image: 'https://via.placeholder.com/400x400/e8f5e9/333333?text=Mailer+Box+5',
    images: [],
    moq: '500 pieces',
    priceRange: '$0.35 - $1.20',
    description: 'E flute corrugated mailer carton with custom logo for minimalist jewelry packaging.',
    specifications: [
      { label: 'Material', value: 'E Flute Corrugated' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 6,
    name: 'Custom Logo Packaging Large Cardboard Carton Mailer Box Baby Clothing Shoes',
    category: 'Mailer Box',
    categoryId: 1,
    image: 'https://via.placeholder.com/400x400/fce4ec/333333?text=Mailer+Box+6',
    images: [],
    moq: '500 pieces',
    priceRange: '$0.70 - $2.20',
    description: 'Large cardboard carton mailer box for baby clothing and shoes with custom logo.',
    specifications: [
      { label: 'Material', value: 'Cardboard' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  // Magnetic Gift Box 系列
  {
    id: 7,
    name: 'New Electronic Products Custom Color Special Gift Present Foldable Hard Case Envelope Shape Magnetic Luxury',
    category: 'Magnetic Gift Box',
    categoryId: 2,
    image: 'https://via.placeholder.com/400x400/1a237e/ffffff?text=Magnetic+Box+1',
    images: [
      'https://via.placeholder.com/600x600/1a237e/ffffff?text=Magnetic+1-1',
      'https://via.placeholder.com/600x600/283593/ffffff?text=Magnetic+1-2'
    ],
    moq: '500 pieces',
    priceRange: '$1.50 - $4.00',
    description: 'Luxury foldable hard case magnetic gift box with envelope shape design for electronic products.',
    specifications: [
      { label: 'Material', value: 'Art Paper + Cardboard' },
      { label: 'Closure', value: 'Magnetic' },
      { label: 'Finish', value: 'Hot Stamping' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 8,
    name: 'Premium Folding Paperboard Car Perfume Packaging Magnetic Box with Matt Lamination Embossing UV Coating',
    category: 'Magnetic Gift Box',
    categoryId: 2,
    image: 'https://via.placeholder.com/400x400/311b92/ffffff?text=Magnetic+Box+2',
    images: [],
    moq: '500 pieces',
    priceRange: '$1.80 - $4.50',
    description: 'Premium magnetic box with matt lamination, embossing and UV coating for car perfume packaging.',
    specifications: [
      { label: 'Material', value: 'Paperboard' },
      { label: 'Finish', value: 'Matt Lamination + UV' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 9,
    name: 'Wholesale Custom Eco-Friendly Wig Packaging Box Matt Lamination Embossing Silk Lining Cardboard Flip Design',
    category: 'Magnetic Gift Box',
    categoryId: 2,
    image: 'https://via.placeholder.com/400x400/4a148c/ffffff?text=Magnetic+Box+3',
    images: [],
    moq: '500 pieces',
    priceRange: '$2.00 - $5.00',
    description: 'Eco-friendly wig packaging box with silk lining and flip magnetic design.',
    specifications: [
      { label: 'Material', value: 'Cardboard + Silk' },
      { label: 'Lining', value: 'Silk' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 10,
    name: 'Reusable Colores Green Plant Embossed Privacy Screen Protector Flip Magnetic Carton Book Shaped',
    category: 'Magnetic Gift Box',
    categoryId: 2,
    image: 'https://via.placeholder.com/400x400/2e7d32/ffffff?text=Magnetic+Box+4',
    images: [],
    moq: '500 pieces',
    priceRange: '$1.20 - $3.50',
    description: 'Book shaped magnetic carton with embossed design for screen protector packaging.',
    specifications: [
      { label: 'Material', value: 'Art Paper' },
      { label: 'Shape', value: 'Book Style' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 11,
    name: 'Custom Logo Printed Embossed UV Coated Recycled Wig Shoe Black Cardboard Folding Magnetic Style',
    category: 'Magnetic Gift Box',
    categoryId: 2,
    image: 'https://via.placeholder.com/400x400/212121/ffffff?text=Magnetic+Box+5',
    images: [],
    moq: '400 pieces',
    priceRange: '$1.60 - $4.20',
    description: 'Black cardboard folding magnetic box with embossed UV coated finish.',
    specifications: [
      { label: 'Material', value: 'Black Cardboard' },
      { label: 'Finish', value: 'UV Coating' },
      { label: 'MOQ', value: '400 Pieces' }
    ]
  },
  {
    id: 12,
    name: 'Biodegradable High-end Perfume Cardboard Carton Classic Square Magnetic Closure Design',
    category: 'Magnetic Gift Box',
    categoryId: 2,
    image: 'https://via.placeholder.com/400x400/3e2723/ffffff?text=Magnetic+Box+6',
    images: [],
    moq: '500 pieces',
    priceRange: '$1.80 - $4.80',
    description: 'High-end perfume packaging with classic square magnetic closure design.',
    specifications: [
      { label: 'Material', value: 'Recycled Cardboard' },
      { label: 'Shape', value: 'Square' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  // Drawer Box 系列
  {
    id: 13,
    name: 'Flexography Embossed Baby Comb Cardboard Carton Twisted Window Display Sliding Custom Drawer Box',
    category: 'Drawer Box',
    categoryId: 3,
    image: 'https://via.placeholder.com/400x400/ff8a65/333333?text=Drawer+Box+1',
    images: [],
    moq: '500 pieces',
    priceRange: '$0.80 - $2.50',
    description: 'Custom drawer box with window display and embossed printing for baby products.',
    specifications: [
      { label: 'Material', value: 'Cardboard' },
      { label: 'Style', value: 'Sliding Drawer' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 14,
    name: 'Wireless Bluetooth Earphone Embossing Custom Paperboard Slide Out Drawer Box Packaging',
    category: 'Drawer Box',
    categoryId: 3,
    image: 'https://via.placeholder.com/400x400/42a5f5/ffffff?text=Drawer+Box+2',
    images: [],
    moq: '500 pieces',
    priceRange: '$0.90 - $2.80',
    description: 'Custom paperboard slide out drawer box for wireless bluetooth earphone packaging.',
    specifications: [
      { label: 'Material', value: 'Paperboard' },
      { label: 'Style', value: 'Slide Out' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 15,
    name: 'Biodegradable Paperboard Retail Ready Carry Handle Slide Out Phone Case Display Custom Logo Drawer Box',
    category: 'Drawer Box',
    categoryId: 3,
    image: 'https://via.placeholder.com/400x400/66bb6a/ffffff?text=Drawer+Box+3',
    images: [],
    moq: '500 pieces',
    priceRange: '$0.70 - $2.20',
    description: 'Retail ready drawer box with carry handle for phone case display.',
    specifications: [
      { label: 'Material', value: 'Biodegradable Paperboard' },
      { label: 'Feature', value: 'Carry Handle' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 16,
    name: 'Recyclable Luxury Beauty Product Cardboard Sliding Drawer Boxes Custom Printing for Cosmetics Packaging',
    category: 'Drawer Box',
    categoryId: 3,
    image: 'https://via.placeholder.com/400x400/ef5350/ffffff?text=Drawer+Box+4',
    images: [],
    moq: '500 pieces',
    priceRange: '$1.00 - $3.00',
    description: 'Luxury sliding drawer boxes for cosmetics packaging with custom printing.',
    specifications: [
      { label: 'Material', value: 'Recyclable Cardboard' },
      { label: 'Use', value: 'Cosmetics' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  {
    id: 17,
    name: 'Biodegradable Christmas Large Mysterious Cosmetics Sliding Drawer Advent Calendar Makeup Gift Box',
    category: 'Drawer Box',
    categoryId: 3,
    image: 'https://via.placeholder.com/400x400/c62828/ffffff?text=Drawer+Box+5',
    images: [],
    moq: '500 pieces',
    priceRange: '$2.00 - $5.50',
    description: 'Christmas advent calendar makeup gift box with sliding drawer design.',
    specifications: [
      { label: 'Material', value: 'Biodegradable' },
      { label: 'Theme', value: 'Christmas' },
      { label: 'MOQ', value: '500 Pieces' }
    ]
  },
  // Paper Bag 系列
  {
    id: 18,
    name: 'Custom Logo Printed Recyclable Kraft Paper Shopping Bag with Handle',
    category: 'Paper Bag',
    categoryId: 4,
    image: 'https://via.placeholder.com/400x400/d7ccc8/333333?text=Paper+Bag+1',
    images: [],
    moq: '1000 pieces',
    priceRange: '$0.20 - $0.80',
    description: 'Custom logo printed recyclable kraft paper shopping bag with twisted handle.',
    specifications: [
      { label: 'Material', value: 'Kraft Paper' },
      { label: 'Handle', value: 'Twisted Paper' },
      { label: 'MOQ', value: '1000 Pieces' }
    ]
  },
  {
    id: 19,
    name: 'Luxury Laminated Gift Paper Bag with Ribbon Handle Custom Design',
    category: 'Paper Bag',
    categoryId: 4,
    image: 'https://via.placeholder.com/400x400/bcaaa4/ffffff?text=Paper+Bag+2',
    images: [],
    moq: '1000 pieces',
    priceRange: '$0.50 - $1.50',
    description: 'Luxury laminated gift paper bag with ribbon handle and custom design.',
    specifications: [
      { label: 'Material', value: 'Art Paper + Lamination' },
      { label: 'Handle', value: 'Ribbon' },
      { label: 'MOQ', value: '1000 Pieces' }
    ]
  },
  {
    id: 20,
    name: 'Eco-friendly Flat Handle Paper Bag for Food Takeaway',
    category: 'Paper Bag',
    categoryId: 4,
    image: 'https://via.placeholder.com/400x400/a1887f/ffffff?text=Paper+Bag+3',
    images: [],
    moq: '2000 pieces',
    priceRange: '$0.10 - $0.40',
    description: 'Eco-friendly flat handle paper bag ideal for food takeaway packaging.',
    specifications: [
      { label: 'Material', value: 'Kraft Paper' },
      { label: 'Handle', value: 'Flat' },
      { label: 'MOQ', value: '2000 Pieces' }
    ]
  }
]

export default products

// 根据分类获取产品
export function getProductsByCategory (categoryId) {
  return products.filter(p => p.categoryId === categoryId)
}

// 根据ID获取产品
export function getProductById (id) {
  return products.find(p => p.id === id)
}

// 获取相关产品
export function getRelatedProducts (productId, limit = 4) {
  const product = products.find(p => p.id === productId)
  if (!product) return []
  return products
    .filter(p => p.categoryId === product.categoryId && p.id !== productId)
    .slice(0, limit)
}
